// v3/layouts/MobileLayout.tsx — Phone bottom nav on the navy chassis
// The five sections live here; the long tail (tools, settings, session)
// lives in the chassis app bar's avatar menu (AppLayout). No hamburger.
// Zero imports from v1/v2.

import { NavLink } from 'react-router-dom';
import * as Icons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '../design-system/utils';
import { NAVIGATION_ITEMS } from '../config/navigation.config';
import { usePermission } from '../shared/hooks/usePermission';

function getIcon(name: string): LucideIcon {
  return (Icons as unknown as Record<string, LucideIcon>)[name] ?? Icons.Circle;
}

export function BottomNav() {
  const { canAccessFeature } = usePermission();
  const items = NAVIGATION_ITEMS
    .filter((i) => i.bottomNav != null && canAccessFeature(i.featureId))
    .sort((a, b) => (a.bottomNav ?? 0) - (b.bottomNav ?? 0));

  if (items.length === 0) return null;

  return (
    <nav
      aria-label="Primary"
      className="flex shrink-0 items-stretch justify-around pb-[env(safe-area-inset-bottom)]"
    >
      {items.map((item) => {
        const Icon = getIcon(item.icon);
        return (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              cn(
                'flex h-[52px] min-w-[56px] flex-col items-center justify-center gap-0.5 text-[10px] font-semibold tracking-wide transition-colors duration-fast',
                isActive ? 'text-white' : 'text-[var(--m-sidebar-fg)] opacity-65 hover:opacity-90',
              )
            }
          >
            <Icon className="h-[19px] w-[19px]" strokeWidth={1.75} />
            {item.shortLabel ?? item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
